module.exports = __webpack_public_path__ + "img/113.6.763b9aab.png";